module.exports = __webpack_public_path__ + "static/mobx-810763d25eed1c6be8d94ef19c48b57b.jpg";